export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const GET_FOLDERS = 'getFolders'
export const SAVE_MAILSLIST = 'SAVE_MAILSLIST'
export const CHANGE_SELECTALL = 'CHANGE_SELECTALL'
export const CHANGE_MAILSORT = 'CHANGE_MAILSORT'
export const SAVE_SELECTIDS = 'SAVE_SELECTIDS'
export const SAVE_FOLEDERID = 'SAVE_FOLEDERID'
export const SAVE_ORIGINLIST = 'SAVE_ORIGINLIST'
export const GET_USERINFO = 'getUserInfo'
export const SAVE_MAILDATA = 'SAVE_MAILDATA'
export const SAVE_BASESET = 'SAVE_BASESET'
export const SAVE_SKIN = 'SAVE_SKIN'
export const SET_COLUMN = 'SET_COLUMN'
export const SET_DIALOG = 'SET_DIALOG'
export const GET_CONTACT_LIST = 'GET_CONTACT_LIST'
export const SET_SEAECH_TEXT = 'SET_SEAECH_TEXT'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js